import { render, staticRenderFns } from "./TopicList.vue?vue&type=template&id=5af8eb01&lang=pug"
import script from "./TopicList.vue?vue&type=script&lang=ts"
export * from "./TopicList.vue?vue&type=script&lang=ts"
import style0 from "./TopicList.vue?vue&type=style&index=0&id=5af8eb01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports